var elMatches = Element.prototype.matches ||
// @ts-ignore
Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var elClosest = Element.prototype.closest || function (selector) {
  var el = this;
  if (!document.documentElement.contains(el)) {
    return null;
  }
  do {
    if (elMatches.call(el, selector)) {
      return el;
    }
    el = el ? el.parentElement || el.parentNode : null;
  } while (el !== null && el.nodeType === 1);
  return null;
};
export default function closest(el, selector) {
  if (el instanceof Element) {
    return elClosest.call(el, selector);
  } else {
    return null;
  }
}